(function() {

	"use strict";

	/**
	*	Quick Cache service for my-account page
	*/
	angular
		.module( "ATMGurus" )
		.service('MyAccountService', AccountService);

	AccountService.$inject = ["ApiQuery", "FilterService", "$q", "ErrorService"];

	 function AccountService(ApiQuery, FilterService, $q, ErrorService) {

		let endpoint = undefined
		let filters = undefined

	 	var service = {
	 		cleanup: cleanup,
	 		getItem: getItem,
 			endpoint: endpoint,
 			agingReport: function(item_number, filters) {
 				return getItem('cwi-inventory-aging', true, [item_number], filters);
			 },
 			tracking: function(order_number) {
 				return getItem('order-tracking', true, [order_number], undefined)
			 },
 			filters: filters, 	// passed in url as querystring ?key=value
 			params: undefined, 	// passed as query params /param/param
	 	}

	 	/////// PRIVATE

		var
			cachedItems = [],
			loading = false;


		function getItem(item, forceReload, forceParameters, forceFilters, csv_download) {

			var defer = $q.defer()

			switch (item) {
				case "saved-carts":
					endpoint = "account/carts/";
					service.params = [];
					filters = 'saved-carts';
					break;
				case "orders":
					endpoint = "account/orders";
					service.params = [];
					filters = 'orders';
					break;
				case "invoice-aging":
					endpoint = "account/invoices/aging-details";
					service.params = [];
					filters = 'myAccount';
					break;
				case "address-book":
					endpoint = "account/address-book";
					service.params = [];
					filters = 'myAccount';
					break;
				case "invoices":
					endpoint = "account/invoices"
					service.params = [];
					filters = 'invoices';
					break;
				case "repairs":
					// @TODO this will be the first query, we'll get the index of status from it
					endpoint = service.endpoint = "account/repairs/report-statuses";
					service.params = [];
					filters = '';
					break;
				case "repairs-category": // sub category of reparis aka after pressing a button
					endpoint = service.endpoint = "account/repairs/report";
					service.params = [];
					filters = 'account-repairs';
					break;
				case "recently-shipped":
					// endpoint = "account/recently-shipped-report";
					endpoint = "account/repairs/recently-shipped-report";
					service.params = [365];
					filters = 'recently-shipped';
					break;
				case "inventory-usage":
					endpoint = "account/cwi/shipped-report";
					service.params = [];
					filters = 'inventory-usage';
					break;
				case "cwi-inventory-aging":
					endpoint = "account/cwi/aging-report";
					service.params = service.params || [];
					filters = 'cwi-inventory-aging';
					break;
				case "order-tracking":
					endpoint = "account/orders/tracking";
					service.params = service.params || [];
					filters = undefined;
					break;
				default:
					endpoint = "account/" + item;
					service.params = [];
					filters = 'myAccount';
			}

			// unique cacheId based on filters and item ['orders', 'saved-carts', ...] being viewed
			var cacheId = item + JSON.stringify(FilterService.get(filters));

			if ( _.isUndefined(cachedItems[cacheId]) || forceReload) {
				var defer = $q.defer(),
					appliedFilters = undefined,
					parameters = ''; // url parameters [param, param] => /param/param

				if (service.params.length) var parameters = '/' + service.params.join('/');

				if (forceParameters) parameters = '/' + forceParameters.join('/');

				if (forceFilters) {appliedFilters = forceFilters;}
				else if (filters) {appliedFilters = FilterService.get(filters)}

				if (csv_download) {
					var defer = $q.defer()
					endpoint += '-download';
					defer.resolve(endpoint + parameters);
					return defer.promise;
				}
				return ApiQuery(endpoint + parameters, appliedFilters, "GET")
					.then(function(response) {
						var returnObj = {pagination: response.data.pagination}
						returnObj['content'] = response.data.data
						cachedItems[cacheId] = returnObj;
						defer.resolve(returnObj);
						return returnObj;
					}, function(reason) {
						defer.reject(reason.message);
					})
			} else {
				defer.resolve(cachedItems[cacheId])
			}

			return defer.promise;
		}

		function cleanup() {
			cachedItems = [];
		}

		return service;

	}

})()


// WEBPACK FOOTER //
// ./src/app/services/ATMGMyAccountService.js